import React from 'react';
import classNames from 'classnames';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { CloseCircleIcon } from '@mm/icons';
import { hideSlideoutMenu } from '@mm/state/actions/viewActions';
import { StoreState } from '@mm/state/store-interfaces';
import { SlideoutMenu } from '../../components/SlideoutMenu';
import EditConnectionPanel from '../../../../features/connections/panels/EditConnectionPanel/EditConnectionPanel';
import './SlideoutJSONWebhooks.pcss';
import { useSlideoutOnClose } from '../SlideoutEmail/SlideoutEmail';

export type Props = {
  className?: string;
  connectionIdFromSlideout?: number;
  isSlideout?: boolean;
  reloadConnections?: () => void;
};

export const SlideoutJSONWebhooks = ({
  className,
  connectionIdFromSlideout,
  isSlideout,
  reloadConnections,
}: Props) => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const { setRef } = useSlideoutOnClose();

  return (
    <SlideoutMenu
      className={classNames(className, 'json-webhook-slideout-menu')}
      setRef={setRef}
    >
      <SlideoutMenu.Content className="json-webhook-slideout__content">
        <div className="json-webhook-slideout-header-container">
          <span
            className="json-webhook-slideout-header_close-btn"
            onClick={() => dispatch(hideSlideoutMenu())}
          >
            <CloseCircleIcon className="widget-adder-slideout-menu__close-icon" />
          </span>
        </div>
        <EditConnectionPanel
          connectionIdFromSlideout={connectionIdFromSlideout}
          isSlideout={isSlideout}
          reloadConnections={reloadConnections}
        />
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
};
